import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';


import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { ValueLabel } from 'src/app/shared/base/base.models';
import { CostPolicy, CostPolicyType } from '../cost-policies.models';
import { PolicyUserType, BusinessPartner } from '../../rebate-policies/rebate-policies.models';
import { PointsOfSaleService } from '../../points-of-sale/points-of-sale.service';
import { PaymentMethodsService } from '../../payment-methods/payment-methods.service';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { PaymentMethod } from '../../payment-methods/payment-methods-models';
import { Product } from '../../products/products.models';
import { MeanOfDelivery } from '../../means-of-delivery/means-of-delivery.models';
import { MeansOfDeliveryService } from '../../means-of-delivery/means-of-delivery.service';
import { OptionsSource } from 'src/app/core/core.models';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { DialogService } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';
import { CostPoliciesService } from '../cost-policies.service';
import { TaxRate } from '../../tax-rate/tax-rate.models';


@Component({
  selector: 'app-cost-policies-form',
  templateUrl: './cost-policies-form.component.html',
  styleUrls: ['./cost-policies-form.component.scss']
})
export class CostPoliciesFormComponent extends BaseFormComponent implements OnInit {
  public tabs: string[] = ['PRODUCTS'];
  public products: Product[] = [];
  public productsSource: OptionsSource;
  public selectedProduct: Product;

  public costPolicyTypes: ValueLabel[] = [];
  public policyUserTypes: ValueLabel[] = [];

  public pointsOfSale: OptionsSource;
  public paymentMethods: OptionsSource;
  public meansOfDelivery: OptionsSource;
  public taxRates: OptionsSource;

  public minDateFrom: Date = new Date();

  public isProductsModalVisible: boolean = false;
  public showPaymentMethod: boolean = false;
  public showMeansOfDelivery: boolean = false;

  public businessPartner: BusinessPartner = {
    name: '',
    companyId: this.authService.companyId,
    active: true,
    version: 0
  };

  constructor(
    private meansOfDeliveryService: MeansOfDeliveryService,
    private pointsOfSaleService: PointsOfSaleService,
    private paymentMethodsService: PaymentMethodsService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService,
    protected costPoliciesService: CostPoliciesService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService)
  }


  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.url = `${Constants.contextPath}/cost-policies`;
    this.prepareLookupData();
    this.prepareFormData(new CostPolicy(), (response: CostPolicy) => {
      return this.modifyResponse(response);
    });
  }

  prepareLookupData() {
    this.costPolicyTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(CostPolicyType, true), 'value', 'label', 'ENUMS.COST_POLICY_TYPES.');
    this.policyUserTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(PolicyUserType, true), 'value', 'label', 'ENUMS.REBATE_POLICY_USER_TYPES.');

    this.pointsOfSale = this.pointsOfSaleService.getPointsOfSaleOptions();
    this.paymentMethods = this.paymentMethodsService.getPaymentMethodsOptions();
    this.meansOfDelivery = this.meansOfDeliveryService.getMeansOfDeliveryOptions();
    this.taxRates = this.costPoliciesService.getTaxRateOptions();
  }

  public modifyResponse(response: CostPolicy) {
    response.breadcrumbsId = response.documentNumber;

    if (response.type)
      this.disableFieldsBasedOnTypeValue(response.type)

    if (response.businessPartner) {
      this.businessPartner = <BusinessPartner>response.businessPartner;
      response.businessPartner = <string>this.businessPartner.name;
    }

    if (response.pointOfSale) {
      let pointOfSale = <PointOfSale>response.pointOfSale;
      response.pointOfSale = pointOfSale.id;
    }

    if (response.paymentMethod) {
      let paymentMethod = <PaymentMethod>response.paymentMethod;
      response.paymentMethod = paymentMethod.id;
    }

    if (response.meansOfDelivery) {
      let meansOfDelivery = <MeanOfDelivery>response.meansOfDelivery;
      response.meansOfDelivery = meansOfDelivery.id;
    }

    if (response.taxRate) {
      let taxRate = <TaxRate>response.taxRate;
      response.taxRate = taxRate.id;
    }

    return response;
  }

  public saveChanges(): void {
    if (!this.isFormValid())
      return;

    this.formData.orderValueFrom = this.formData.orderValueFrom ? this.formData.orderValueFrom : 0;
    this.formData.orderValueTo = this.formData.orderValueTo ? this.formData.orderValueTo : 0;

    let data = { ...this.formData };

    // TODO: Vidjeti business partner kako se salje
    // this.businessPartner.name = this.formData.businessPartner;
    // data.businessPartner = this.businessPartner;

    if (this.id == null)
      this.baseService.create(this.url, data, () => {
        this.onSaveSuccess();
      });
    else
      this.baseService.update(this.url, data, () => {
        this.onSaveSuccess();
      });
  }

  public typeChanged = (event) => {
    this.disableFieldsBasedOnTypeValue(event.value, true)
  }

  private disableFieldsBasedOnTypeValue(value, alterData = false) {
    switch (value) {
      case CostPolicyType[CostPolicyType.ADMINISTRATIVE_COST]:
        this.showPaymentMethod = false;
        this.showMeansOfDelivery = false;

        if (alterData) {
          this.formData.paymentMethod = null;
          this.formData.meansOfDelivery = null;
        }
        break;
      case CostPolicyType[CostPolicyType.MEANS_OF_DELIVERY]:
        this.showPaymentMethod = false;
        this.showMeansOfDelivery = true;

        if (alterData) {
          this.formData.paymentMethod = null;
        }
        break;
      case CostPolicyType[CostPolicyType.PAYMENT_METHOD]:
        this.showPaymentMethod = true;
        this.showMeansOfDelivery = false;

        if (alterData) {
          this.formData.paymentMethod = null;
        }
        break;
    }
  }
}
